import {configure, defineRule, ErrorMessage, Field, Form} from 'vee-validate';
import {localize, setLocale} from '@vee-validate/i18n';
import de from '@vee-validate/i18n/dist/locale/de.json';
import val_de from './vee-validate/val_de.json'
import {defineNuxtPlugin} from 'nuxt/app'
import * as rules from '@vee-validate/rules'
import moment from 'moment'

const rulesForErrorMessage = [
    'validation_pending',
    'isInvalid',
    'phoneInvalid',
    'ibanInvalid'
]

export default defineNuxtPlugin((nuxtApp) => {

    /**************
     * Custom rules
     **************/

    // defineRule('confirm_password', (value, [password]) => value === password);
    rulesForErrorMessage.forEach(rule => defineRule(rule, () => false))


    defineRule('tooManyFemales', (value) => {
        return value <= 0
    });

    defineRule('tooManyMales', (value) => {
        return value <= 0
    });

    defineRule('tooManyParticipants', (value) => {
        return value <= 0
    });

    defineRule('participantsRequired', (value) => {
        return value > 0
    });

    defineRule('personsRequired', (value) => {
        return value > 0
    });

    defineRule('correctDateFormat', (value) => {
        return value?.length >= 6 // YYYY-MM-DD is default, IE11 might allow text, so DDMMYY is minimum
    });

    defineRule('correctAge', (value) => {
        return moment(value).isAfter(moment().subtract(125, 'years'))
            && moment(value).isSameOrBefore(moment());
    });

    defineRule('phone', (value) => {
        return value && /^[0-9+\-/() ]{3,}$/.test(value)
    });

    defineRule('addressIsIncomplete', (value) => {
        return !!value
    });

    defineRule('invoiceRecipient', (value) => {
        return !!value
    });

    defineRule('contactPerson', (value) => {
        return !!value
    });

    defineRule('regexWithMessage', (value, [regex, message]) => {
        if (value.toString().match(regex)) return true
        return message
    });

    defineRule('includes', (value, [text, message]) => {
        if (value.toString().toLowerCase().includes(text.toLowerCase())) return true
        return message ? message : false
    });
    /**************
     * Configuration
     **************/

    Object.keys(rules).forEach(rule => {
        if (rule === 'all') return;
        defineRule(rule, rules[rule]);
    });

    setLocale('de');

    nuxtApp.vueApp.component("VField", Field)
    nuxtApp.vueApp.component("VForm", Form)
    nuxtApp.vueApp.component("ErrorMessage", ErrorMessage)

    configure({
        generateMessage: localize({
            de: {...de, messages: {...de.messages, ...val_de.messages}, names: {...de.names, ...val_de.names}}
        }),
        classes: {
            valid: 'is-valid',
            invalid: 'is-invalid',
            dirty: ['is-dirty', 'is-dirty'] // multiple classes per flag!
        }
    });
})